<div class="head">
  <mat-form-field>
    <input [(ngModel)]="title" matInput placeholder="Title" required/>
  </mat-form-field>
  <button (click)="save()" color="primary" mat-raised-button>Add</button>
</div>

<div class="available">
  <h3>Available</h3>
  <data-table
    (detail)="assignItem($event)"
    *ngIf="availableItemsProvider"
    [columns]="columns"
    [dataProviderParams]="{}"
    [dataProvider]="availableItemsProvider"
    [table_id]="'available'">
  </data-table>
</div>

<div class="assigned">
  <h3>Assigned
  </h3>
  <data-table
    #assignedItemsTable
    (remove)="removeAssignedItem($event)"
    [columns]="columns"
    [dataProviderParams]="{}"
    [dataProvider]="assignedItemsProvider"
    [table_id]="'assigned'">
  </data-table>
</div>

